module.exports = __webpack_public_path__ + "img/info-1440.d8782b4e.png";